'use strict';
require('./CompanyNoticeService.js');

function dateIsEqual(a, b) {
  if(a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  return false;
}

CompanyNoticeDetailCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  '$translate',
  'noticeCategories',
  'CompanyNoticeService',
  'notice',
  'growl'];
function CompanyNoticeDetailCtrl(
  $scope,
  $stateParams,
  $state,
  $translate,
  noticeCategories,
  CompanyNoticeService,
  notice,
  growl) {
    $scope.noticeCategories = noticeCategories;
    $scope.notice = notice;

    $scope.notice.enddate   = new Date($scope.notice.enddate);
    $scope.notice.reminderAt     = new Date($scope.notice.reminderAt);

    $scope.isEdited = false;
    $scope.selectedMonth = null;
    
    $scope.setNoticePeriod = function(m) {
      $scope.selectedMonth = m;
      $scope.notice.reminderAt = moment($scope.notice.enddate).subtract(m, (m === 1 ? 'month' : 'months'));
      if (m === 1) {
        $scope.notice.noticePeriod = $translate.instant('task.1-month');
      } else if(m === 2) {
        $scope.notice.noticePeriod = $translate.instant('task.2-months');
      } else if(m === 3) {
        $scope.notice.noticePeriod = $translate.instant('task.3-months');
      } else if(m === 6) {
        $scope.notice.noticePeriod = $translate.instant('task.6-months');
      } else if (m === 9) {
        $scope.notice.noticePeriod = $translate.instant('task.9-months');
      } else if (m === 12) {
        $scope.notice.noticePeriod = $translate.instant('task.12-months');
      }
    };

    $scope.checkReminderDate = function() {
      if($scope.notice.reminderAt >= $scope.notice.enddate) {
        $scope.setNoticePeriod(1);
      }
    };

    $scope.$watch("[notice.enddate,notice.reminderAt]", function(newValue, oldValue) {
      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
         newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
        $scope.checkReminderDate();
      }
      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])){
        $scope.setNoticePeriod($scope.selectedMonth);
      }
    }, true);
 
    $scope.saveNotice = function() {
      var r  = angular.copy($scope.notice);
      r.$update({companyId: $stateParams.companyId, noticeId: r.id}, function(){
        growl.addSuccessMessage($translate.instant('notices.update-success'));
        $scope.isEdited = true;
      }, function(){
        growl.addErrorMessage($translate.instant('notices.update-failure'));
      });
    };

    $scope.setCompleted = function() {
      if ($scope.notice.status) {
        $scope.notice.status = false;
      }else{
        $scope.notice.status = true;
      }
      $scope.saveNotice();
      $scope.hide(true);
    };

    $scope.hide = function(isEdited) {
      if ($state.current.name !== 'root.company.notices.detail') {
        $scope.$hide();
      } else {
        if ($scope.isEdited === true || angular.isDefined(isEdited)) {
          $state.go('.^', {}, {reload: true});
        } else {
          $state.go('.^');
        }
      }
    };

    $scope.deleteReminder = function(reminder) {
      CompanyNoticeService.delete({companyId: $stateParams.companyId, noticeId: reminder.id}, function(){
        growl.addSuccessMessage($translate.instant('notices.delete-success'));
      }, function(){
        growl.addErrorMessage($translate.instant('notices.delete-failure'));
      })
    }
}

CompanyNoticeDetailCtrl.resolve = {
  notice: ['$stateParams', 'CompanyNoticeService', function($stateParams, CompanyNoticeService) {
    return CompanyNoticeService.get({
      companyId: $stateParams.companyId,
      noticeId: $stateParams.noticeId
    }).$promise;
  }],
  noticeCategories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
    return CompanyCategoryService.query({companyId: $stateParams.companyId, type: 'REMINDER_CATEGORY'}).$promise;
  }]
};

module.exports = CompanyNoticeDetailCtrl;

angular.module('dokiv')
  .controller('CompanyNoticeDetailCtrl', CompanyNoticeDetailCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/notices/CompanyNoticeDetailCtrl.js
// module id = 363
// module chunks = 0